<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.sentmessages')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.sentmessage.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
    </div>

    <div table>
      <p-table [value]="sentmessages">
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th pSortableColumn="recipient">{{ t('common.labels.recipient') }}
              <p-sortIcon field="recipient"></p-sortIcon>
            </th>
            <th pSortableColumn="type">{{ t('common.labels.type') }}
              <p-sortIcon field="type"></p-sortIcon>
            </th>
            <th pSortableColumn="sended_at">{{ t('common.labels.sended_at') }}
              <p-sortIcon field="sended_at"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sentmessage>
          <tr tabindex="0" class="tr-hover" [ngClass]="{error: sentmessage.sended_at === null}" (click)="onShowContent(sentmessage)">
            <td>
              <i class="pi pi-check" *ngIf="sentmessage.sended_at !== null"></i>
              <i class="pi pi-exclamation-circle" *ngIf="sentmessage.sended_at === null" [pTooltip]="t('sentmessages.error_on_sending')"></i>
            </td>
            <td><span>{{sentmessage.recipient}}</span></td>
            <td><span>{{ t('common.labels.' + sentmessage.type) }}</span></td>
            <td>
              <span *ngIf="sentmessage.sended_at !== null">{{sentmessage.sended_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm'}} {{ t('common.labels.oclock') }}</span>
              <span *ngIf="sentmessage.sended_at === null && sentmessage.created_at !== null">({{ t('sentmessages.transmission_attempt') }}: {{sentmessage.created_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm'}} {{ t('common.labels.oclock') }})</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>

  <p-dialog [header]="t('common.labels.message')" [(visible)]="messageVisible" [style]="{width: '80vw'}" [draggable]="false" [modal]="true">
    <div class="maildata">
      <p>{{ t('common.labels.recipient') }}: <strong>{{ messageSelected?.recipient }}</strong></p>
      <p>{{ t('common.labels.sended') }}:
        <strong *ngIf="messageSelected?.sended_at !== null">{{ messageSelected?.sended_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm' }} {{ t('common.labels.oclock') }}</strong>
        <ng-container *ngIf="messageSelected?.sended_at === null">
          <strong><span class="error">{{ t('sentmessages.error_on_sending') }}</span></strong> ({{ t('sentmessages.transmission_attempt') }}: {{messageSelected?.created_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm'}} {{ t('common.labels.oclock') }})
        </ng-container>
      </p>
    </div>
    <div class="mailcontent" [innerHtml]="messageSelected?.content"></div>
  </p-dialog>

</ng-container>
